import { useEffect } from "react";
import ApresentacaoVideoGate from "./ApresentacaoVideoGate";

export default function ApresentacaoPage() {
  useEffect(() => {
    document.title = "Evolzap — Apresentação";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Conheça o Evolzap — CRM completo com Inteligência Artificial para transformar sua operação."
      );
    }
    window.scrollTo(0, 0);

    // Oculta o webchat do Evolzap (app.evolzap.com/widget.js) apenas nesta rota.
    // O widget monta um unico <div id="evz-webchat-root"> no body, sem Shadow DOM,
    // entao basta uma regra de CSS — que vale mesmo se o script carregar depois daqui.
    const style = document.createElement("style");
    style.setAttribute("data-origin", "apresentacao-hide-chat");
    style.textContent = "#evz-webchat-root { display: none !important; }";
    document.head.appendChild(style);

    return () => {
      const existente = document.head.querySelector(
        'style[data-origin="apresentacao-hide-chat"]'
      );
      if (existente) existente.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <main className="animate-fade-in py-4 md:py-12">
        <ApresentacaoVideoGate />
      </main>
    </div>
  );
}
